import React from 'react';
import AppSwitch from 'src/components/common/AppSwitch';
import { IScheduledActionsGroup } from 'src/store/modules/adManager/adScheduledActionGroups/types';
import { SCHEDULED_ACTION_STATUS } from 'sl-ad-campaign-manager-data-model';
import RulesUpdateModal from 'src/components/AddModals/RulesUpdateModal';

export const RuleStatusSwitch = ({ data }: { data: IScheduledActionsGroup }) => {
  return (
    <>
      <AppSwitch
        switchProps={{
          checked: data?.scheduledActions[0]?.scheduledAction?.status === SCHEDULED_ACTION_STATUS.ENABLED,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            RulesUpdateModal.setData(data);
            RulesUpdateModal.setChangeEvent(e);
            RulesUpdateModal.show();
          }
        }}
      />
    </>
  );
};
